import { createCrudStore } from "@/store/crudStore";

const cosechasStore = createCrudStore("cosechas");

export default {
  ...cosechasStore,
  actions: {
    ...cosechasStore.actions,
    getCosechas: cosechasStore.actions.getAllStates,
    postCosecha: cosechasStore.actions.create,
    patchCosecha: cosechasStore.actions.update,
    deleteCosecha: cosechasStore.actions.delete,
  },
};
